<template>
  <div class="match-scores">
    <!-- 总比分 -->
    <div class="m-score-wrap whole-score">
      <!-- 主队得分 -->
      <div
        :class="['m-score m-match-score', {
          'up': scoreStatus.wholeScores === 1
        }]"
      >
        {{ wholeScores[0] }}
      </div>

      <!-- 客队得分 -->
      <div
        :class="['m-score m-match-score', {
          'up': scoreStatus.wholeScores === -1
        }]"
      >
        {{ wholeScores[1] }}
      </div>
    </div>

    <!-- 节比分 -->
    <div
      v-if="sectionScores"
      class="m-score-wrap"
    >
      <!-- 主队得分 -->
      <div
        :class="['m-score m-match-score', {
          'up': scoreStatus.sectionScores === 1
        }]"
      >
        {{ sectionScores[0] }}
      </div>

      <!-- 客队得分 -->
      <div
        :class="['m-score m-match-score', {
          'up': scoreStatus.sectionScores === -1
        }]"
      >
        {{ sectionScores[1] }}
      </div>
    </div>

    <!-- 小节比分 -->
    <div
      v-if="currentSectionScores"
      class="m-score-wrap"
    >
      <!-- 主队得分 -->
      <div
        :class="['m-score', {
          'up': scoreStatus.currentSectionScores === 1
        }]"
      >
        {{ currentSectionScores[0] }}
      </div>

      <!-- 客队得分 -->
      <div
        :class="['m-score', {
          'up': scoreStatus.currentSectionScores === -1
        }]"
      >
        {{ currentSectionScores[1] }}
      </div>
    </div>
  </div>
</template>

<script>
import useMatchScore from './composables/useMatchScore.js'

export default {
  props: {
    scoreOfWholeMatch: {
      type: String,
      default: ''
    },
    scoreOfSection: {
      type: [String, Array],
      default: ''
    },
    scoreInCurrentSection: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const { scoreStatus, wholeScores, sectionScores, currentSectionScores } = useMatchScore(props)

    return {
      scoreStatus,
      wholeScores,
      sectionScores,
      currentSectionScores
    }
  }
}
</script>

<style lang="scss" scoped>
.match-scores {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: flex-end;

  .m-score-wrap {
    &.whole-score {
      color: #ffca27;
    }

    .m-score {
      &.up {
        color: #00b359;
      }
    }
  }
}

.m-score-wrap {
  min-width: 16px;
  color: #ccc;
  text-align: center;

  &:last-child {
    text-align: right;
  }
}

.m-score:first-child {
  margin-bottom: 8px;
}

[data-mode="light"] {
  .match-scores .m-score-wrap.whole-score {
    color: #FF7D1E;
  }
}
</style>
